import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import classNames from 'classnames';
import type { FC } from 'react';
import React, { Fragment } from 'react';

import { useWidget } from '../../../../../../../contexts/widgets';
import { ProfileAlignment } from '../../../../../../../types';
import styles from './Title.scss';

export const Title: FC = () => {
  const { t } = useTranslation();
  const { isRTL } = useEnvironment();
  const { member, computed } = useWidget();

  const { isDesignPreview, isDisplayPreview, profileAlignment } = computed;
  const title = member.title;
  const shouldShowTitlePreview =
    (isDesignPreview || isDisplayPreview) && !title;

  const isRightAlignment =
    profileAlignment === ProfileAlignment.Right && !isRTL;
  const isCenterAlignment = profileAlignment === ProfileAlignment.Center;

  return (
    <>
      {title && (
        <div
          className={classNames({
            [styles.container]: true,
            [styles.isRightAlignment]: isRightAlignment,
            [styles.isCenterAlignment]: isCenterAlignment,
          })}
        >
          <p className={styles.title}>{title}</p>
        </div>
      )}
      {shouldShowTitlePreview && (
        <div className={styles.container}>
          <p className={styles.title}>{t('design-tab.title-preview')}</p>
        </div>
      )}
    </>
  );
};
